import React from 'react';

const ChemicalsIcon = ({
  width = 31,
  height = 31,
  fill = 'none',
  className,
}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 62 62' className={className}>
      <g fill={fill} fillRule='evenodd'>
        <path fill='#FFF' d='M40.5 42.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-14.935-1.243a1.998 1.998 0 1 1-2.809-.322 1.998 1.998 0 0 1 2.809.322zm20.434-8.258a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-19-13.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-.948 16.451a7 7 0 0 1-.001-9.899 6.998 6.998 0 0 1 9.9 0 6.999 6.999 0 0 1 0 9.899 6.999 6.999 0 0 1-9.9 0zm1.413-8.485a5.001 5.001 0 0 0 7.072 7.072 5.001 5.001 0 0 0-7.072-7.072zM42 20a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM20 30.818a3 3 0 1 1-5.999.002 3 3 0 0 1 6-.002z'
        />
        <circle cx='31' cy='31' r='30.5' stroke='#FFF' />
      </g>
    </svg>
  );
};

export default ChemicalsIcon;


// WEBPACK FOOTER //
// ./src/app/intro/components/ChemicalsIcon/ChemicalsIcon.js